import { render, staticRenderFns } from "./AbsenceDelayAddModal.vue?vue&type=template&id=227796df"
import script from "./AbsenceDelayAddModal.vue?vue&type=script&lang=js"
export * from "./AbsenceDelayAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports